/**
 * Split an order address — one pre-composed `"street…, City, State ZIP"` string on the wire — into
 * the street and the `City, State ZIP` locality, so the Logistics card never breaks the city across
 * two lines. The break is found from the order's own `city`, matched as a whole comma-separated
 * part (last occurrence, case-insensitive), never guessed from the shape of the string: where the
 * city is not found, or starts the address, the address comes back whole, as one line.
 */
export function addressLines(address: string, city: string): string[] {
  const parts = address.split(',');
  const target = city.trim().toLowerCase();
  const at = parts.findLastIndex((part, i) => i > 0 && part.trim().toLowerCase() === target);
  if (!target || at === -1) return [address];
  return [parts.slice(0, at).join(',').trim(), parts.slice(at).join(',').trim()];
}
